const LOADING = "loading"
const ERROR = "error"
const WAITING = "waiting"
const CHOICE = "choise"
const DEALING = "dealing"
const GAME = "game"
const BUSY = "busy"

export { LOADING, ERROR, WAITING, CHOICE, GAME, BUSY, DEALING } 